import { Grid, Skeleton } from "@mui/material";

function SkeletonLoading({ isOpen, height = 118, count = 6, xs = 12, sm = 6, md = 4, lg = 3 }) {
  if (!isOpen) return null;

  return (
    <Grid container spacing={1}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item xs={xs} sm={sm} md={md} lg={lg} key={index}>
          <Skeleton variant="rounded" animation="wave" height={height} />
        </Grid>
      ))}
    </Grid>
  );
}

export default SkeletonLoading;
